import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';
import { ButtonVariant } from '../../enums/button-variant';
import { ButtonSizeEnum } from '../../enums/button-size.enum';
import { SvgIconComponent } from 'angular-svg-icon';
import { ButtonStateEnum } from '../../enums/button-state.enum';

@Component({
  selector: 'evsb-button',
  templateUrl: './base-button.component.html',
  styleUrls: ['./base-button.component.scss'],
})
export default abstract class BaseButtonComponent implements AfterContentInit {
  @Input()
  public renderAsLink = false;
  @Input()
  public href: string;
  @Input()
  public state = ButtonStateEnum.enabled;
  @Input()
  public type = 'button';
  @Input()
  public fullWidth = false;
  @Input()
  public size = ButtonSizeEnum.regular;
  @ContentChildren(SvgIconComponent)
  public icons: QueryList<SvgIconComponent>;
  protected variant: ButtonVariant;
  public get className(): string {
    return `${this.variant} ${this.size} ${this.state}`;
  }

  public ngAfterContentInit() {
    this.fillIconsWithCurrentTextColor();
  }

  private fillIconsWithCurrentTextColor() {
    this.icons?.forEach((icon) => (icon.svgClass = 'fill-current'));
  }
}
